<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { Vue3Lottie } from 'vue3-lottie'

import rank1st from '../../assets/animations/1st.json'
import rank2nd from '../../assets/animations/2nd.json'
import rank3rd from '../../assets/animations/3rd.json'

import druming from '../../assets/audios/druming.wav'
import top1Music from '../../assets/audios/top_1_music.wav'
import top1Sfx from '../../assets/audios/top_1_sfx.wav'
import top2Music from '../../assets/audios/top_2_music.wav'
import top2Sfx from '../../assets/audios/top_2_sfx.wav'
import top3Music from '../../assets/audios/top_3_music.wav'
import top3Sfx from '../../assets/audios/top_3_sfx.wav'

import { audioManager } from '../../utils/audioManager';
import { QuizAudioKey } from '../../types/quiz';

interface Props {
    start?: boolean
    placement: number
    assets?: string
    size?: number
    width?: string
    height?: string
}
const props = withDefaults(defineProps<Props>(), {
    start: true,
    placement: 1,
    assets: '',
    width: '100%',
    height: '100%'
})
const count = ref<number>(0)

const emit = defineEmits(['finish', 'loop'])

const animationList = [
    { ad: rank1st, lf: 233 },
    { ad: rank2nd, lf: 120 },
    { ad: rank3rd, lf: 120 }
]

const soundEffectList = [
    druming,
    top2Music,
    top3Music
]

const animationData = computed(() => {
    return animationList[props.placement - 1]
})

const lottieContainer = ref()
const loopFromFrame = () => {
    lottieContainer.value.goToAndPlay(animationData.value.lf, true)
}

watch(() => props.start, (newVal) => {
    if (newVal) {
        lottieContainer.value.play()
        return
    }
    lottieContainer.value.stop()
})

function handleFrame() {
    count.value++
    if (props.placement === 1 && count.value === 190) {
        audioManager.play(top1Music, QuizAudioKey.BGM)
        setTimeout(() => {
            audioManager.play(top1Sfx, 'noise')
        }, 250)
    }
    if (props.placement === 2 && count.value === 100) {
        audioManager.play(top2Sfx, 'noise')

    }
    if (props.placement === 3 && count.value === 100) {
        audioManager.play(top3Sfx, 'noise')

    }


    if (count.value === (animationList[props.placement - 1].lf - 1)) {

        emit('loop', props.placement)
    }
    if (count.value === lottieContainer.value.getDuration(true)) {
        emit('finish', props.placement)
    }

}
function playSound() {
    audioManager.play(soundEffectList[props.placement - 1], QuizAudioKey.BGM)
}

onMounted(() => {
    if (props.placement === 0) {
        emit('loop', props.placement)
    }
})
onBeforeUnmount(() => {
    audioManager.stop('noise')
})
</script>
<template>
    <Vue3Lottie ref="lottieContainer" :animationData="animationData.ad" :assets-path="props.assets" @on-loop-complete="loopFromFrame" @on-enter-frame="handleFrame()" v-on:on-animation-loaded="playSound()" :height="props.height" :width="props.width"
        v-if="props.placement <= 3 && props.placement > 0" />
    <div class="flex justify-center items-center p-2 rounded-full " :style="{ width: props.width, height: props.height }" v-else>
        <img class="w-full max-w-md h-full" :src="props.assets" alt="" :height="props.height" :width="props.width">
    </div>
</template>